import { render, staticRenderFns } from "./index.vue?vue&type=template&id=027725e9&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=027725e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027725e9",
  null
  
)

export default component.exports